export const DEFAULT_FONT_SIZE = 50;
export const MAX_OUTLINE_SIZE = 25;
export const MAX_SHADOW_SIZE = 50;
